import { useCallback, useEffect, useState } from "react"
import { TokensResponse } from "../../../../../backend/src/routes/schemes"

export type AppAuthProviderTokensProps = {
    tokens?: TokensResponse
    setTokens: (tokens: TokensResponse) => void
    reset: () => void
    isBusy: boolean
}

const LOCALSTORAGEKEY_TOKENS = "nexum-schvalovak-tokens"

const useAppAuthProviderTokens = (): AppAuthProviderTokensProps => {
    const [tokens, setTokens] = useState<TokensResponse | undefined | null>()

    const resetLocalStorage = useCallback(() => {
        localStorage.removeItem(LOCALSTORAGEKEY_TOKENS)
    }, [])

    const reset = useCallback(() => {
        setTokens(undefined)
        resetLocalStorage()
    }, [resetLocalStorage])

    useEffect(() => {
        if (tokens) localStorage.setItem(LOCALSTORAGEKEY_TOKENS, JSON.stringify(tokens))
        else {
            const storaged = localStorage.getItem(LOCALSTORAGEKEY_TOKENS)
            try {
                if (storaged) {
                    const tokens = JSON.parse(storaged) as TokensResponse
                    setTokens(tokens)
                } else setTokens(null)
            } catch (e) {
                setTokens(null)
            }
        }
    }, [tokens])

    return {
        tokens: tokens ?? undefined,
        isBusy: tokens === undefined,
        setTokens: (tokens: TokensResponse) => setTokens(tokens),
        reset,
    }
}
export default useAppAuthProviderTokens
